import useAuthStore from '@/store/auth';
import { useRouter } from 'next/router';
import React, { ReactElement, ReactNode, useEffect } from 'react';

import apiConfig from '@/config/url-api';

interface Props {
  children: ReactNode;
  fallback: ReactElement;
}

export default function GuestGuard(props: Props) {
  const { children, fallback } = props;

  const router = useRouter();
  const authStore = useAuthStore((state) => state);

  useEffect(() => {
    if (!router.isReady) {
      return;
    }

    if (window.localStorage.getItem(apiConfig.auth.storageTokenKeyName)) {
      const returnUrl = (router.query?.returnUrl as string) || '/apps';
      router.push(returnUrl);
    }
  }, [router.route]);

  if (authStore.user != null) {
    return fallback;
  }

  return <>{children}</>;
}
